'use strict';
module.exports = function wordWrap(text, maxWidth, widthFunction, LineBreaker) {
	if (!LineBreaker) {
		throw 'line breaker not set';
	}
	let currentLine = '',
		start = 0,
		space,
		chunkWidth = 0;

	const breaker = new LineBreaker(text || ''),
		lines = [],
		finishLine = function () {
			const lineText = currentLine.trim(),
				lineWidth = widthFunction(lineText);
			lines.push({
				text: lineText,
				width: lineWidth
			});
			currentLine = '';
		},
		reflowRequired = function () {
			return maxWidth && (chunkWidth > maxWidth);
		},
		processWord = function (currentWord) {
			const rtrimWord = currentWord.replace(/\s+$/, ''),
				currentWordWidth = widthFunction(rtrimWord),
				potentialLineWidth = widthFunction(currentLine + rtrimWord);
			if (maxWidth && (potentialLineWidth > maxWidth)) {
				finishLine();
				currentLine = currentWord;
			} else {
				currentLine = currentLine + currentWord;
			}
			return currentWordWidth;
		};
	while ((space = breaker.nextBreak()) && (!reflowRequired())) {
		chunkWidth = processWord(text.slice(start, space.position));
		if (space.required) {
			finishLine();
		}
		start = space.position;
	}
	if (reflowRequired()) {
		return wordWrap(text, chunkWidth, widthFunction, LineBreaker);
	} else {
		if (currentLine.length) {
			finishLine();
		}
		return lines;
	}
};
